export default "__VITE_ASSET__DAsxAUDL__"